/* eslint-disable jsdoc/require-returns */
/* eslint-disable jsdoc/require-param-description */
/* eslint-disable no-promise-executor-return */
/* eslint-disable jsdoc/require-param-type */
/* eslint-disable no-sequences */
/* eslint-disable no-use-before-define */
/* eslint-disable valid-typeof */
/* eslint-disable no-console */
/* eslint-disable consistent-return */
/* eslint-disable func-names */
/* eslint-disable no-shadow */
/* eslint-disable no-new */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-plusplus */
/* eslint-disable eqeqeq */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
/* eslint-disable import/no-extraneous-dependencies */
/* jQuery is provided by vendor.js and Swiper by swiper.min.js. */

globalThis.header = {
  selectors: {
    sectionId: '#shopify-section-header',
    dataSlicky: '[data-sticky]',
  },
  _offsetTop: () => {
    const offTop = $(header.selectors.sectionId)[0].offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${offTop}px`);
    return offTop;
  },
  _runSlicky: (time) => {
    setTimeout(() => {
      if ($(window)[0].scrollY > 0) $(header.selectors.sectionId).addClass('sticky-installed');
      else $(header.selectors.sectionId).removeClass('sticky-installed');
    }, time);
  },
  _initSlicky: () => {
    const $dataSlicky = $(header.selectors.dataSlicky, $(header.selectors.sectionId));

    if ($dataSlicky.data('sticky')) {
      $(header.selectors.sectionId).addClass('shopify-section-header--sticky');
      header._offsetTop();
      header._runSlicky(300);
      $(window).on('scroll', () => header._runSlicky());
    } else $(header.selectors.sectionId).removeClass('shopify-section-header--sticky');

    return $dataSlicky.data('sticky');
  },
  _init: () => {
    if ($(header.selectors.sectionId).length > 0) {
      if (!header._initSlicky()) header._offsetTop();
    }
  },
  _run() {
    header._init();
  },
};

globalThis.mutationMain = () => {
  $(document).on('shopify:section:select', function (event) {
    if (load && target?.className.indexOf('shopify-section-header') > 0) {
      header._run();
    }
    if (event.target.className.indexOf('shopify-section-cookies') > 0) cookies._run();
    if (load && target?.className.indexOf('index-section--slideshow-ultimate') > 0) slideshow._run();
  });

  $(document).on('shopify:block:select', function ({ detail }) {
    const { blockId, sectionId } = detail;
    const selector_swiperId = `#SlideShowUltimate-${sectionId}`;
    if ($(`${selector_swiperId} #swiperSlide-${blockId}`).length > 0) {
      const autorotate = $(selector_swiperId).data('autorotate');
      const slideIndex = $(`${selector_swiperId} #swiperSlide-${blockId}`).data('slider-slide-index');

      autorotate && $(selector_swiperId).data('autorotate', false);
      sessionStorage.setItem(selector_swiperId, autorotate);
      $(selector_swiperId).data('slide-to', slideIndex);
      $(selector_swiperId)[0].swiper !== undefined && (slideshow.listSwiper[selector_swiperId].autoplay.stop(), slideshow.listSwiper[selector_swiperId].slideToLoop(slideIndex));
    }
  });

  $(document).on('shopify:block:deselect', function ({ detail }) {
    const { blockId, sectionId } = detail;
    const selector_swiperId = `#SlideShowUltimate-${sectionId}`;

    if ($(`${selector_swiperId} #swiperSlide-${blockId}`).length > 0) {
      $(selector_swiperId).data('autorotate', sessionStorage.getItem(selector_swiperId));
      slideshow._run();
    }
  });
};

globalThis._setCookie = function (cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
};

globalThis._getCookie = function (cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

globalThis.slideshow = {
  listSwiper: {},
  listVideo: {},
  selectors: {
    container: '.slideShowUltimate-container',
    paginationEl: '.slideShowUltimate-pagination',
    nextEl: '.slideShowUltimate__arrow-next',
    prevEl: '.slideShowUltimate__arrow-prev',
    scrollbarEl: '.slideShowUltimate-scrollbar',
    paused: '.slideShowUltimate__pause',
    activeEl: '.swiper-slide-active',
    activeElMobil: '.slideShowUltimate__text-content--mobile-active',
    slideImage: '.swiper-slide .slideshow__image',
    dataSliderBtnIndex: '[data-slider-btn-index]',
    youtube: '.slideShowUltimate__youtube',
    videoLocal: '[video-local]',
  },
  _getBool: (swiperId, dataName) => {
    return typeof $(swiperId).data(dataName) === 'boolean' ? $(swiperId).data(dataName) : $(swiperId).data(dataName) == 'true';
  },
  _isBackgrounImage: async (swiperId) => {
    let equal = true;
    await $.each($(slideshow.selectors.slideImage, $(swiperId)), (key, item) => {
      if ($(item).attr('style')?.indexOf('background-image') === -1) {
        equal = false;
        return false;
      }
      if ($(slideshow.selectors.slideImage, $(swiperId)).length === key + 1) {
        equal = true;
        return true;
      }
    });
    return equal;
  },
  _initVideo: ($sectionId) => {
    if ('IntersectionObserver' in window) {
      const lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (video, key) {
          $(video.target).attr('id', `video_${key}`);
          const playOn = $(video.target).closest('.swiper-slide').hasClass('swiper-slide-active');
          const mq = $(window).width() > theme.breakpoints.phone ? '[video-local-lap]' : '[video-local-phone]';

          if (video.isIntersecting) {
            for (const source in video.target.children) {
              const videoSource = video.target.children[source];
              if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                videoSource.src = videoSource.dataset.src;
              }
            }

            video.target.load();
            video.target.classList.remove('lazy');
            lazyVideoObserver.unobserve(video.target);

            playOn && !$(mq, $(slideshow.selectors.activeEl)).hasClass('lazy') && $(mq, $(slideshow.selectors.activeEl)).trigger('play');
          }
        });
      });

      $.each($('video.lazy'), function () {
        lazyVideoObserver.observe(this);
      });

      $(window).on('resize', () => {
        slideshow._playVideo($sectionId);
      });
    }
  },
  _playVideo: ($sectionId) => {
    $.each($(slideshow.selectors.videoLocal, $sectionId), function () {
      const mq = $(window).width() > theme.breakpoints.phone ? '[video-local-lap]' : '[video-local-phone]';
      const playOn = $(this).is(mq) && $(this).closest('.swiper-slide').hasClass('swiper-slide-active');
      const playing = playOn && $(this).get(0).paused;

      !$(this).hasClass('lazy') && (!playOn && $(this).trigger('pause'), playing && $(this).trigger('play'));
    });
  },
  _initYoutube: () => {
    $.getScript('https://www.youtube.com/player_api', function () {
      YT.ready(() => {
        $.each($(slideshow.selectors.youtube, $(slideshow.selectors.container)), (key, item) => {
          $(item).attr('id', `ytplayer_${key}`);

          const youtubeId = $(item).data($(window).width() > theme.breakpoints.phone ? 'id' : 'id-phone');
          const playerId = `ytplayer_${key}`;
          const playOn = $(item).closest('.swiper-slide').hasClass('swiper-slide-active');

          $(item).prop('tagName') === 'IFRAME' && ($(item).after(slideshow.listVideo[playerId].m.outerHTML), $(item).remove(), delete slideshow.listVideo[playerId]);

          youtubeId &&
            (slideshow.listVideo[playerId] = new YT.Player(playerId, {
              videoId: youtubeId,
              playerVars: {
                cc_load_policy: 0,
                controls: 0,
                disablekb: 0,
                enablejsapi: 1,
                fs: 0,
                hl: theme.currency,
                iv_load_policy: 3,
                loop: 1,
                modestbranding: 1,
                origin: theme.domain,
                playsinline: 1,
                rel: 0,
                showinfo: 0,
                mute: 1,
              },
              events: {
                onReady: (event) => {
                  playOn && event.target.playVideo();
                  event.target.mute();
                },
                onStateChange: ({ target, data }) => {
                  const start = $(target.h).closest(slideshow.selectors.activeEl).length;
                  start && data == 0 && target.playVideo();
                },
                onError: (data) => console.info('[YT error] ', data),
              },
            }));

          $(window).on('resize', () => {
            if (slideshow.listVideo.hasOwnProperty(playerId)) {
              const dataMq = $(item).data($(window).width() > theme.breakpoints.phone ? 'id' : 'id-phone');

              dataMq !== undefined && dataMq === '' && slideshow._initYoutube();
              slideshow.listVideo[playerId].getVideoUrl().indexOf(dataMq) == -1 && slideshow._initYoutube();
            } else {
              $(item).data($(window).width() > theme.breakpoints.phone ? 'id' : 'id-phone') !== '' && slideshow._initYoutube();
            }
          });
        });
      });
    });
  },
  _playYoutube: (play, id) => {
    $.each(slideshow.listVideo, (key, item) => {
      slideshow.listVideo[key].hasOwnProperty('pauseVideo') &&
        typeof slideshow.listVideo[key]?.pauseVideo !== undefined &&
        (slideshow.listVideo[key].pauseVideo(), $(item.h).addClass('pause-video'));
    });
    play &&
      slideshow.listVideo.hasOwnProperty(id) &&
      slideshow.listVideo[id].hasOwnProperty('playVideo') &&
      slideshow.listVideo[id]?.playVideo !== undefined &&
      (slideshow.listVideo[id]?.playVideo(), $(slideshow.listVideo[id]?.h).removeClass('pause-video'));
  },
  _initSwiper: (swiperId, sectionId) => {
    if (slideshow.listSwiper[swiperId] !== undefined) slideshow.listSwiper[swiperId].destroy();

    const autoplay = slideshow._getBool(swiperId, 'autorotate');
    const loop = slideshow._getBool(swiperId, 'loop');

    slideshow.listSwiper[swiperId] = new Swiper(swiperId, {
      slidesPerView: 1,
      loop,
      simulateTouch: loop,
      loopAdditionalSlides: 0,
      pagination: {
        el: sectionId + slideshow.selectors.paginationEl,
        clickable: true,
        renderBullet: $(swiperId).data('pagination')
          ? function (index, className) {
              return `<span class="${className}" title="${$(`[data-slider-slide-index="${index}"]`).data('pagination-title')}">${$(`[data-slider-slide-index="${index}"]`).data(
                'pagination-title'
              )}</span>`;
            }
          : null,
      },
      navigation: {
        nextEl: sectionId + slideshow.selectors.nextEl,
        prevEl: sectionId + slideshow.selectors.prevEl,
      },
      scrollbar: {
        el: sectionId + slideshow.selectors.scrollbarEl,
        draggable: true,
      },
      autoplay: autoplay && {
        delay: $(swiperId).data('speed'),
      },
      speed: 600,
      on: {
        afterInit(swiper) {
          const slideTo = $(swiperId).data('slide-to');
          const autorotate = typeof $(swiperId).data('autorotate') === 'boolean' ? $(swiperId).data('autorotate') : $(swiperId).data('autorotate') == 'true';

          slideTo !== undefined && (swiper.slideToLoop(slideTo), $(swiperId).removeData('slide-to'));
          autorotate ? swiper.autoplay.start() : swiper.autoplay.stop();
          if ($(slideshow.selectors.youtube, $(slideshow.selectors.container)).length > 0) slideshow._initYoutube();

          $('video.lazy', $(sectionId)).length > 0 && slideshow._initVideo($(sectionId));

          if (swiper.autoplay.running) {
            $(slideshow.selectors.paused, swiper.$el).removeClass('is-paused');
            $(slideshow.selectors.paused, swiper.$el).on('click', function () {
              $(this).toggleClass('is-paused');
              if ($(this).hasClass('is-paused')) swiper.autoplay.stop();
              else swiper.autoplay.start();
            });
          } else $(slideshow.selectors.paused, swiper.$el).addClass('is-paused');
        },
        slideChangeTransitionEnd(swiper) {
          const key = $(slideshow.selectors.activeEl, $(sectionId)).data('slider-slide-index');
          $(`${slideshow.selectors.activeElMobil}:not([data-slider-mobile-content-index="${key}"])`).removeClass(slideshow.selectors.activeElMobil.replace('.', ''));
          $(`[data-slider-mobile-content-index="${key}"]`).addClass(slideshow.selectors.activeElMobil.replace('.', ''));

          $(slideshow.selectors.dataSliderBtnIndex).length > 0 &&
            ($(slideshow.selectors.dataSliderBtnIndex).removeClass('active'), $(slideshow.selectors.dataSliderBtnIndex.replace(']', `="${key}"]`)).addClass('active'));

          const $yt = $(slideshow.selectors.youtube, $(slideshow.selectors.activeEl, $(sectionId)));
          const isYT = $yt.length > 0;

          $.isEmptyObject(slideshow.listVideo) || slideshow._playYoutube(isYT, $yt.attr('id'));

          const $video = $(slideshow.selectors.videoLocal, $(sectionId));
          const isVideo = $video.length > 0;

          isVideo && slideshow._playVideo($(sectionId));

          swiper?.autoplay.running ? $(slideshow.selectors.paused, swiper.$el).removeClass('is-paused') : $(slideshow.selectors.paused, swiper.$el).addClass('is-paused');
        },
      },
    });
  },
  _init: () => {
    if ($(slideshow.selectors.container).length > 0) {
      $.each($(slideshow.selectors.container), async function () {
        const swiperId = `#${$(this).attr('id')}`;
        const sectionId = `#shopify-section-${$(swiperId).data('section-id')} `;
        const slides_style = setInterval(async function () {
          if (await slideshow._isBackgrounImage(swiperId)) {
            slideshow._initSwiper(swiperId, sectionId);
            clearInterval(slides_style);
          }
        });
      });
    }
  },
  _run: () => slideshow._init(),
};

(globalThis.cookies = {
  _init: () => {
    if (_getCookie('page-cookies') === $('#shopify-section-cookies [data-cookies-version]').data('cookies-version')) $('#shopify-section-cookies').addClass('hide');
    else $('#shopify-section-cookies').addClass('installed');
    $(document).on('click', '.cookies__btn-close', function () {
      _setCookie('page-cookies', $('#shopify-section-cookies [data-cookies-version]').data('cookies-version'), 30);
      $('#shopify-section-cookies').hide('slow');
    });
  },
  _run: () => cookies._init(),
}),
  (globalThis.checkbox = {
    _template: (id, key) => {
      return `<div class="checkbox--xBox" id="checkbox-${key}"><label for="${id}">${theme.iconCheck}${theme.iconChecked}</label></div>`;
    },
    _init: (father) => {
      const $checkboxInputs = father ? $('input[type="checkbox"]', $(father)) : $('input[type="checkbox"]');
      $.each($checkboxInputs, (key, input) => {
        const $input = $(input);
        const id = $(input).attr('id');
        const name = $(input).attr('name');
        if (id) $input.after(checkbox._template(id, key));
        else {
          $input.attr('id', name + key);
          $input.after(checkbox._template(name + key, key));
        }
        $input.prependTo(`#checkbox-${key}`);
      });
    },
    _run: () => checkbox._init(),
  }),
  (globalThis.newsletter = {
    selectors: {
      newsletterInput: '#Contact_newsletter-email',
      newsletter: '.newsletter-section__regulations',
    },
    _init: () => {
      $(newsletter.selectors.newsletterInput).on('keyup', () => {
        $(newsletter.selectors.newsletter).slideDown();
      });
    },
    _run: () => newsletter._init(),
  }),
  (globalThis.metafildTable = {
    selectors: {
      showBtn: '.show-btn',
      metafildTableBtn: '.product-metafields .show-btn',
      metafildTable: '.product-metafields .metafilds-show:not(.gpsr)',
      metafildTableBtnActive: '.product-metafields .show-btn__active',
      metafildTableBtnHide: '.product-metafields .show-btn__hide',
      sectionHeader: '.product-metafields .section-header:not(.gpsr)',
    },
    _init: () => {
      if ($(metafildTable.selectors.showBtn).length > 0) {
        $(metafildTable.selectors.showBtn).appendTo(metafildTable.selectors.sectionHeader);
      }
      $(metafildTable.selectors.metafildTableBtn).on('click', () => {
        $(metafildTable.selectors.metafildTable).slideToggle('slow');
        $(metafildTable.selectors.metafildTableBtnActive).toggle();
        $(metafildTable.selectors.metafildTableBtnHide).toggle();
      });
    },
    _run: () => metafildTable._init(),
  }),
  (globalThis.fullWidthVideo = {
    selectors: {
      pauseButton: '.fullWidthVideo__control__pause',
      resumeButton: '.fullWidthVideo__control__resume',
      stopButton: '.fullWidthVideo__control__stop',
      mainPlayButton: '#fullWidthVideoButton',
      fullWidthVideoId: '#fullWidthVideo',
      isFullVideoLocalFile: true,
      playerContainer: '.fullWidthVideo',
      controlsPanel: '.fullWidthVideo__controls',
      lazyVideos: '.fullWidthVideo__video-wrapper__video.lazy',
      player: '',
    },
    _localVideoPlayer: () => {
      return $('.fullWidthVideo__video-wrapper__video:visible')[0];
    },
    _stopVideo: () => {
      if (!fullWidthVideo.selectors.isFullVideoLocalFile) {
        fullWidthVideo.selectors.player.seekTo(0);
        fullWidthVideo.selectors.player.stopVideo();
      } else {
        fullWidthVideo._localVideoPlayer().currentTime = 0;
        fullWidthVideo._localVideoPlayer().pause();
      }
      if ($(fullWidthVideo.selectors.playerContainer).hasClass('running')) {
        $(fullWidthVideo.selectors.playerContainer).removeClass('running');
      }
      if ($(fullWidthVideo.selectors.controlsPanel).hasClass('paused')) {
        $(fullWidthVideo.selectors.controlsPanel).removeClss('paused');
      }
    },
    _playVideo() {
      $(fullWidthVideo.selectors.playerContainer).addClass('running');
      if (!fullWidthVideo.selectors.isFullVideoLocalFile) {
        fullWidthVideo.selectors.player.playVideo();
        return;
      }
      fullWidthVideo._localVideoPlayer().play();
    },
    _resumeVideo() {
      if ($(fullWidthVideo.selectors.controlsPanel).hasClass('paused')) {
        $(fullWidthVideo.selectors.controlsPanel).removeClass('paused');
      }
      if (!fullWidthVideo.selectors.isFullVideoLocalFile) {
        fullWidthVideo.selectors.player.seekTo(0);
        fullWidthVideo.selectors.player.playVideo();
        return;
      }
      fullWidthVideo._localVideoPlayer().currentTime = 0;
      fullWidthVideo._localVideoPlayer().play();
    },
    _pauseAndPlayVideo() {
      if (!$(fullWidthVideo.selectors.controlsPanel).hasClass('paused')) {
        $(fullWidthVideo.selectors.controlsPanel).addClass('paused');
        if (!fullWidthVideo.selectors.isFullVideoLocalFile) {
          fullWidthVideo.selectors.player.pauseVideo();
        } else {
          fullWidthVideo._localVideoPlayer().pause();
        }
        return;
      }
      $(fullWidthVideo.selectors.controlsPanel).removeClass('paused');
      if (!fullWidthVideo.selectors.isFullVideoLocalFile) {
        fullWidthVideo.selectors.player.playVideo();
        return;
      }
      fullWidthVideo._localVideoPlayer().play();
    },
    _onPlayerStateChange(event) {
      if (event.data == 2) {
        $(fullWidthVideo.selectors.controlsPanel).addClass('paused');
      }
      if (event.data == 0) {
        fullWidthVideo._stopVideo();
      }
    },
    _init: () => {
      const videoFromYoutube = $(fullWidthVideo.selectors.fullWidthVideoId);

      if ('IntersectionObserver' in window && $(videoFromYoutube).length == 0) {
        const fullVideoObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (video, key) {
            if (video.isIntersecting) {
              for (const source in video.target.children) {
                const videoSource = video.target.children[source];
                if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                  videoSource.src = videoSource.dataset.src;
                }
              }

              video.target.load();
              video.target.classList.remove('lazy');
              fullVideoObserver.unobserve(video.target);
            }
          });
        });

        $.each($(fullWidthVideo.selectors.lazyVideos), function () {
          fullVideoObserver.observe(this);
        });
      }

      if ($(videoFromYoutube).length) {
        fullWidthVideo.selectors.isFullVideoLocalFile = false;
        $.getScript('https://www.youtube.com/player_api', function () {
          YT.ready(() => {
            if (!fullWidthVideo.selectors.isFullVideoLocalFile) {
              const videoId = $(videoFromYoutube).data('videoid');
              fullWidthVideo.selectors.player = new YT.Player('fullWidthVideo', {
                playerVars: {
                  autoplay: 0,
                  rel: 0,
                  controls: 0,
                },
                videoId,
                events: {
                  onStateChange: fullWidthVideo._onPlayerStateChange,
                },
              });
            }
          });
        });
      }
      $(fullWidthVideo.selectors.mainPlayButton).on('click', fullWidthVideo._playVideo);
      $(fullWidthVideo.selectors.pauseButton).on('click', fullWidthVideo._pauseAndPlayVideo);
      $(fullWidthVideo.selectors.resumeButton).on('click', fullWidthVideo._resumeVideo);
      $(fullWidthVideo.selectors.stopButton).on('click', fullWidthVideo._stopVideo);
      if (fullWidthVideo._localVideoPlayer()) {
        $(fullWidthVideo._localVideoPlayer()).on('ended', fullWidthVideo._stopVideo);
      }
    },
    _run: () => fullWidthVideo._init(),
  }),
  (globalThis.collectionIntroduction = {
    selectors: {
      introductionSlider: '',
      sliderSlides: '.introduction-holder__slider .swiper-slide',
      sliderContainer: '.introduction-holder__slider .swiper-container',
      prevEl: '.introduction-holder .swiper-button-prev',
      nextEl: '.introduction-holder .swiper-button-next',
    },
    _init: () => {
      const { sliderContainer } = collectionIntroduction.selectors;
      if ($(collectionIntroduction.selectors.sliderSlides).length < 1) {
        return;
      }
      new Swiper(sliderContainer, {
        pagination: false,
        loop: false,
        spaceBetween: 0,
        autoplay: false,
        slidesPerView: 'auto',
        navigation: {
          nextEl: collectionIntroduction.selectors.nextEl,
          prevEl: collectionIntroduction.selectors.prevEl,
        },
      });
    },
    _run: () => collectionIntroduction._init(),
  }),
  (globalThis.searchaniseCustomization = {
    selectors: {
      recomendationSlider: '.snize-recommendation-results .overview',
      recomendationNextButton: '.snize-recommendation-results .next',
    },
    _init: () => {
      const styleObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutationRecord) {
          const el = $(mutationRecord.target);
          const maxLeftMargin = Math.abs(Number($(el).css('marginLeft').replace('px', ''))) + Number($(window).outerWidth());
          if (maxLeftMargin >= $(el).outerWidth()) {
            $(el).closest('.snize-recommendation-results').find('.next').addClass('disable');
          } else {
            $(el).closest('.snize-recommendation-results').find('.next').removeClass('disable');
          }
          if (maxLeftMargin > $(el).outerWidth()) {
            $(el).css({ marginLeft: -Math.abs($(el).outerWidth() - $(window).outerWidth()) });
          }
        });
      });
      let count = 0;
      const ReservationInterval = setInterval(() => {
        count++;
        if ($(window).outerWidth() > theme.breakpoints.phone) {
          clearInterval(ReservationInterval);
          return;
        }
        if ($(searchaniseCustomization.selectors.recomendationSlider).length) {
          const sliders = document.querySelectorAll(searchaniseCustomization.selectors.recomendationSlider);
          let i;
          for (i = 0; i < sliders.length; i++) {
            styleObserver.observe(sliders[i], { attributes: true, attributeFilter: ['style'] });
          }

          $(window).on('resize', searchaniseCustomization._onResize);
          searchaniseCustomization._customizeDimensionsOfRecommendations();
          count = 20;
        }
        if (count > 19) {
          clearInterval(ReservationInterval);
        }
      }, 500);
    },
    _onResize() {
      if ($(window).outerWidth() > theme.breakpoints.phone) {
        return;
      }
      searchaniseCustomization._customizeDimensionsOfRecommendations();
    },
    _customizeDimensionsOfRecommendations() {
      const sliders = $(searchaniseCustomization.selectors.recomendationSlider);
      for (const slider of sliders) {
        const slides = $(slider).children();
        const halfViewportWidth = $(slider).closest('.viewport').outerWidth() / 2;
        for (const slide of slides) {
          const slideMargins = $(slide).css('margin-right').replace('px', '') * 2;
          $(slide).css({ width: `${halfViewportWidth - slideMargins}px` });
        }

        $(slider).outerWidth($(slides).first().outerWidth(true) * slides.length);
      }
    },
    _run: () => searchaniseCustomization._init(),
  }),
  (globalThis.shopTheLook = {
    selectors: {
      shopTheLookData: '.shop-the-look__item',
      img: '.shop-the-look__img',
      size: '.shop-the-look__sizes',
      price: '.shop-the-look__price',
      btn: '.shop-the-look__basket',
      btnText: '.shop-the-look__basket .text',
      title: '.shop-the-look__title',
      onlyText: '.text',
      loader: '.loader',
      firstSize: '.shop-the-look__size-item:first-child',
      changeSize: '.shop-the-look__size-item',
      error: '.shop-the-look__error',
    },
    _initProduct: (product) => {
      const $item = $(`[data-attr="${product.handle}"]`);

      $item.find(shopTheLook.selectors.img).append(`<img src="${product.images[0]})" alt="${product.title}"/>`);
      $item.find(shopTheLook.selectors.img).attr('href', product.url);
      $item.find(shopTheLook.selectors.title).append(`<h3>${product.title}</h3>`);

      $.each(product.variants, (i, e) => {
        if (e.available == true) {
          $item.find(shopTheLook.selectors.size).append(`<div class="${e.available} shop-the-look__size-item" data-attr=${e.id}>${e.title}</div>`);
          $item.find(shopTheLook.selectors.changeSize).on('click', (e) => {
            if ($(e.currentTarget).hasClass('false')) {
              $(e.currentTarget).parent().parent().find(shopTheLook.selectors.btnText).text(theme.strings.soldOut);
              $(e.currentTarget).parent().parent().find(shopTheLook.selectors.btn).attr('aria-disabled', true);
            } else {
              $(e.currentTarget).parent().parent().find(shopTheLook.selectors.btnText).text(theme.strings.addToCart);
              $(e.currentTarget).parent().parent().find(shopTheLook.selectors.btn).removeAttr('aria-disabled');
            }
            $(e.currentTarget).parent().find(shopTheLook.selectors.changeSize).removeClass('active');
            $(e.currentTarget).addClass('active');
            $(e.currentTarget).parent().parent().find(shopTheLook.selectors.btn).attr('data-id', $(e.currentTarget).attr('data-attr'));
          });
        }
      });

      if ($item.find(shopTheLook.selectors.firstSize).hasClass('false')) {
        $item.find(shopTheLook.selectors.btn).attr('aria-disabled', true);
        $item.find(shopTheLook.selectors.btnText).text(theme.strings.soldOut);
      }

      $item.find(shopTheLook.selectors.price).append(`<div class="shop-the-look__price-normal">${theme.Currency.formatMoney(product.price, theme.moneyFormat)}</div>`);

      if (product.compare_at_price > product.price) {
        $item.find(shopTheLook.selectors.price).append(`<div class="shop-the-look__price-old">${theme.Currency.formatMoney(product.compare_at_price, theme.moneyFormat)}</div>`);
      }

      $item.find(shopTheLook.selectors.btn).attr('data-id', product.variants[0].id);
      $item.find(shopTheLook.selectors.btn).removeAttr('disabled');
      $item.find(shopTheLook.selectors.firstSize).addClass('active');

      if ($item.find(shopTheLook.selectors.firstSize).hasClass('false')) {
        $item.find(shopTheLook.selectors.btnText).text(theme.strings.soldOut);
      }

      $(shopTheLook.selectors.btn, $item).on('click', function () {
        const $btn = $(this);
        const id = $btn.attr('data-id');
        const formData = {
          items: [
            {
              id,
              quantity: 1,
            },
          ],
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then(async function (response) {
            if (!response.ok) {
              const body = await response.text();
              throw Error(JSON.parse(body).description);
            }
            return response;
          })
          .then(function (response) {
            const $onlyText = $btn.find(shopTheLook.selectors.onlyText);
            const $loader = $btn.find(shopTheLook.selectors.loader);

            $onlyText.text('');
            $loader.removeClass('hide');
            setTimeout(() => {
              $loader.addClass('hide');
              $onlyText.text('Dodano do koszyka!');
              setTimeout(() => {
                $loader.addClass('hide');
                $onlyText.text(theme.strings.addToCart);
              }, 2000);
            }, 200);
            $btn.parent().find(shopTheLook.selectors.error).text('');
          })
          .catch(function (error) {
            $btn.parent().find(shopTheLook.selectors.error).text(error);
            console.error('Error:', error);
          });
      });
    },
    _init: () => {
      if ($(shopTheLook.selectors.shopTheLookData).length > 0) {
        const swiperShopTheLook = new Swiper('.shop-the-look', {
          slidesPerView: 1,
          spaceBetween: 0,
          observer: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            980: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 60,
            },
          },
        });
        const count = $(shopTheLook.selectors.shopTheLookData).length;
        $(shopTheLook.selectors.shopTheLookData).each((i, e) => {
          const handle = $(e).data('attr');

          fetch(`/products/${handle}.js`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          })
            .then(async function (response) {
              if (!response.ok) {
                $(`[data-attr="${handle}"]`).remove();
              }
              return response;
            })
            .then(async function (response) {
              const product = await response.json();
              shopTheLook._initProduct(product);
              if ($(e).find(shopTheLook.selectors.changeSize).length == 0) {
                $(e).remove();
              }
            });
          $(shopTheLook.selectors.changeSize).on('click', (e) => {
            if ($(e).hasClass('false')) {
              $(e).parent().parent().find(shopTheLook.selectors.btnText).text(theme.strings.soldOut);
            } else {
              $(e).parent().parent().find(shopTheLook.selectors.btnText).text(theme.strings.addToCart);
            }
          });
        });
      }
    },
    _run: () => shopTheLook._init(),
  }),
  (globalThis.mobileMenu = {
    selectors: {
      menuTextLink: '.gm-text',
    },
    _init: () => {
      $(mobileMenu.selectors.menuTextLink).on('click', function (e) {
        e.stopPropagation();
        $(this).parent().trigger('click');
      });
    },
    _run: () => mobileMenu._init(),
  }),
  (globalThis.fitGuide = {
    selectors: {
      tabID: 'data-tab-id',
      tabsWrapper: '.fit-guide__tabs',
      menuWrapper: '.fit-guide__menu',
      menuItem: '.menu__button',
      tab: '.accordion__tab',
      activeClass: 'active',
      tabHeader: '.tab__header',
      accordionHeadClass: 'accordion__head',
    },
    _init: () => {
      const tabsWrapper = $(fitGuide.selectors.tabsWrapper);
      const menuWrapper = $(fitGuide.selectors.menuWrapper);
      const menuItems = $(fitGuide.selectors.menuItem);
      const tabs = $(fitGuide.selectors.tab);
      const tabHeader = $(fitGuide.selectors.tabHeader);
      /**
       * @param item
       */
      function toggleActiveItem(item) {
        if (!item) return;
        const tabID = item.getAttribute(fitGuide.selectors.tabID);
        tabHeader[0].textContent = item.textContent;
        toggleElementsClass(menuItems, tabID);
        toggleElementsClass(tabs, tabID);
        tabsWrapper[0].scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
      /**
       * @param array
       * @param tabID
       */
      function toggleElementsClass(array, tabID) {
        array.each(function (index, item) {
          if (item.getAttribute(fitGuide.selectors.tabID) === tabID) item.classList.add(fitGuide.selectors.activeClass);
          else item.classList.remove(fitGuide.selectors.activeClass);
        });
      }
      menuWrapper.on('click', function (e) {
        if (e.target.hasAttribute(fitGuide.selectors.tabID)) toggleActiveItem(e.target);
      });
      tabsWrapper.on('click', function (e) {
        if (e.target.classList.contains(fitGuide.selectors.accordionHeadClass)) {
          e.target.classList.toggle(fitGuide.selectors.activeClass);

          if (e.target.classList.contains(fitGuide.selectors.activeClass)) e.target.nextSibling.style.maxHeight = `${e.target.nextSibling.scrollHeight}px`;
          else e.target.nextSibling.style.maxHeight = `${0}px`;
        }
      });
      toggleActiveItem(menuItems[0]);
    },
    _run: () => fitGuide._init(),
  });
globalThis.reviewTooltip = {
  selectors: {
    templateProduct: '.template-product',
    label: '.wc_review_count_text',
    tooltip: 'tooltip',
    question: 'question',
    visible: 'visible',
  },
  _init() {
    /**
     * @param element
     */
    function observeElement(element) {
      return new Promise((resolve) => {
        if (document.querySelector(element)) {
          return resolve(document.querySelector(element));
        }

        const observer = new MutationObserver(() => {
          if (document.querySelector(element)) {
            resolve(document.querySelector(element));
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });
    }
    observeElement(this.selectors.label).then(() => {
      const container = document.querySelector(this.selectors.label);
      const tooltip = document.createElement('span');
      const questionMark = document.createElement('span');

      tooltip.classList.add(this.selectors.tooltip);
      questionMark.classList.add(this.selectors.question);
      questionMark.innerHTML = '?';
      tooltip.innerHTML = theme?.settings?.review;
      container.appendChild(questionMark);
      container.appendChild(tooltip);

      questionMark.addEventListener('mouseenter', () => {
        tooltip.classList.add(this.selectors.visible);
      });

      container.addEventListener('mouseleave', () => {
        tooltip.classList.remove(this.selectors.visible);
      });
    });
  },
  _run() {
    if ($(this.selectors.templateProduct).length > 0) {
      this._init();
    }
  },
};
globalThis.announcementBar = {
  selectors: {
    customAnnBar: '#shopify-section-announcement-bar',
    bolideAnnBar: '.bolide-announcement-bar-wrap',
    stickyClass: 'sticky',
  },
  _moveBolideBar: () => {
    const bolideAnnBar = document?.querySelector(announcementBar.selectors.bolideAnnBar);
    const customAnnBar = document?.querySelector(announcementBar.selectors.customAnnBar);
    if (bolideAnnBar && customAnnBar) customAnnBar.insertAdjacentElement('afterbegin', bolideAnnBar);
  },
  _init: () => {
    const interval = setInterval(() => {
      let counter = 0;
      if (document.querySelector(announcementBar.selectors.bolideAnnBar)) {
        announcementBar._moveBolideBar();
        clearInterval(interval);
      }
      if (counter > 10) {
        clearInterval(interval);
      }
      counter++;
    }, 1000);
  },
  _run: () => announcementBar._init(),
};
globalThis.stickyHeader = {
  _throttle: (func, interval) => {
    let lastCall = 0;
    return function (...args) {
      const now = Date.now();
      if (now - lastCall >= interval) {
        lastCall = now;
        func.apply(this, args);
      }
    };
  },
  _getFiltersData: () => {
    const filters = document.querySelector('.snize-main-panel');
    const filtersHeight = filters ? filters.getBoundingClientRect().height * 1 : 0;
    return { filters, filtersHeight };
  },
  _getHeaderData: () => {
    const header = document.querySelector('#shopify-section-header');
    const headerHeight = header.getBoundingClientRect().height * 1;
    return { header, headerHeight };
  },
  _init: () => {
    if (window.innerWidth >= 769) return; // end script when desktop
    const { header, headerHeight } = stickyHeader._getHeaderData();
    const { filters, filtersHeight } = stickyHeader._getFiltersData();

    header.style.top = `${(headerHeight + filtersHeight) * -1}px`;
    if (filters) filters.style.top = `${(filtersHeight + 3) * -1}px`;

    let lastScroll = 0;
    window.addEventListener(
      'scroll',
      stickyHeader._throttle(() => {
        const { header, headerHeight } = stickyHeader._getHeaderData();
        const { filters, filtersHeight } = stickyHeader._getFiltersData();
        header.style.top = `${(headerHeight + filtersHeight) * -1}px`;
        if (filters) filters.style.top = `${(filtersHeight + 3) * -1}px`;
        const currentScroll = window.scrollY;
        if (currentScroll < headerHeight + filtersHeight + 400 || currentScroll > lastScroll) {
          header.style.transform = 'translateY(0px)';
          if (filters) filters.style.transform = 'translateY(0px)';
        } else if (currentScroll < lastScroll) {
          header.style.transform = `translateY(${headerHeight + filtersHeight}px)`;
          if (filters) filters.style.transform = `translateY(${headerHeight + filtersHeight}px)`;
        }
        lastScroll = currentScroll;
      }, 50)
    );
  },
  _run: () => stickyHeader._init(),
};
$(function () {
  checkbox._run();
  if (Shopify.designMode) mutationMain();
  slideshow._run();
  cookies._run();
  newsletter._run();
  metafildTable._run();
  fullWidthVideo._run();
  collectionIntroduction._run();
  header._run();
  searchaniseCustomization._run();
  shopTheLook._run();
  mobileMenu._run();
  fitGuide._run();
  reviewTooltip._run();
  announcementBar._run();
  stickyHeader._run();
});
